import 'devextreme/dist/css/dx.common.css';
import './themes/generated/theme.base.css';
import './themes/generated/theme.additional.css';
import { createApp } from "vue";
import Vue from "vue";
import router from "./router";
import themes from "devextreme/ui/themes";
import store from "./store"

import App from "./App.vue";
import appInfo from "./app-info";
import { bootstrap } from "../../core/services/bootstrap";

const getRuntimeConfig = async (runtimeConfigFile: string) => {
  const runtimeConfig = await fetch(runtimeConfigFile)
  return runtimeConfig.json()
}

const prodConfig = './prodRuntimeConfig.json'
const localConfig = './localRuntimeConfig.json'

getRuntimeConfig('./runtimeConfig.json').then(function (json) {

  getRuntimeConfig(json.prod ? prodConfig : localConfig).then(function (json) {


    const apiEndpoint = json.VUE_APP_APIURL;
    const modelHub = json.modelHub;
    const apiKey = json.API_KEY;

    store.commit('calendarAPI', json.calendarAPI)

    store.commit('modelHub', modelHub)
    store.commit('VUE_APP_APIURL', apiEndpoint)
    store.commit('apiKey', apiKey)
    // store.commit('testData', json.testData);
    if (json.testData) {
      store.dispatch('loadTestData');
    }


    router.options.routes.forEach((route: { name: string; props: { endpoints: any[]; }; }) => {
      if (route.name === 'create-account') {
        route.props = {
          endpoints: [apiEndpoint]
        }
      }
    })

    createAppAfterAPIInjection()
  })
})

async function createAppAfterAPIInjection() {

    try {

    const token = await bootstrap();
    store.commit('sessionToken', token);

  } 
  catch (err) {
    //FAGRNL
  }

  window.addEventListener('unhandledrejection', function(event) {
    console.error('Unhandled rejection (promise: ', event.promise, ', reason: ', event.reason, ').');
  });

  window.onerror = function (e) {
    console.error("unhandled error: " + e);
  };
  

  const app = createApp(App)
  app.use(router)
  app.use(store)
  app.config.globalProperties.$appInfo = appInfo;
  
  // Add global error handler
  app.config.errorHandler = (err, vm, info) => {
    // Handle the error
    console.error('UNHANDLED ERROR!:', err);
    console.error('UNHANDLED ERROR!: ', info);
    console.error('UNHANDLED ERROR!: ', vm);
    console.error('UNHANDLED ERROR!: ', vm?.$props);

    // We should also log the error to an external service
    // logErrorToService(err, vm, info);
  };

  app.mount('#app')
}


// themes.initialized(() => {
//     const app = createApp(App);
//     app.use(router);
//     app.use(store);
//     app.config.globalProperties.$appInfo = appInfo;
//     app.mount('#app');
// });
